<template>
  <a
    href="https://www.soldera.org/corporate/registry-bridge"
    target="_blank"
    rel="noopener noreferrer"
    class="powered-by-soldera d-flex align-items-center justify-content-center gap-2 w-100 flex-shrink-0"
  >
    <img
      :src="solderaLogo"
      alt="Soldera"
      class="powered-by-soldera__logo flex-shrink-0"
    />
    <span class="text-start">{{ $t("branding.powered_by_soldera") }}</span>
  </a>
</template>

<script setup lang="ts">
import solderaLogo from "@/assets/img/logo/soldera-circular.png";

// Sidebar-footer Soldera attribution; links out to Soldera's registry-bridge
// page in a new tab.
</script>

<style scoped lang="scss">
.powered-by-soldera {
  border: 0;
  background: transparent;
  padding: 0.5rem 0.75rem;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #9b968f;
  text-decoration: none;
  border-top: 1px solid #e5ded6;

  &:hover {
    color: var(--phoenix-primary);
    text-decoration: underline;
  }
}

.powered-by-soldera__logo {
  height: 1.125rem;
  width: 1.125rem;
  border-radius: 50%;
}
</style>
